export const BRAND = {
  name: "Bloc & Brush",
  tagline: "Design. Build. Maintain.",
  phone: "+971 55 355 8669",
  phoneHref: "tel:+971553558669",
  whatsapp: "+971 55 355 8669",
  whatsappHref: "https://wa.me/971553558669",
  email: "info@blocandbrush.ae",
  emailHref: "mailto:info@blocandbrush.ae",
  address: "Business Bay, Dubai, United Arab Emirates",
  hours: "Sat – Thu · 9:00 AM – 7:00 PM",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Showcase", to: "/projects/showcase" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "interior-fit-out",
    title: "Interior Fit-Out",
    description:
      "Luxury residential and commercial fit-outs including civil works, gypsum ceilings, flooring, painting, partitions, joinery and glass works.",
    image:
      "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    slug: "holiday-home-furnishing",
    title: "Holiday Home Furnishing",
    description:
      "Complete furnishing packages designed for Airbnb and holiday home operators. Furniture, decor, media walls, kitchen equipment and guest-ready setup.",
    image:
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    slug: "mep-services",
    title: "MEP Services",
    description:
      "Electrical, mechanical, plumbing, HVAC, lighting, fire alarm, low current systems, testing and commissioning.",
    image:
      "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    slug: "facility-maintenance",
    title: "Facility Maintenance",
    description:
      "Preventive maintenance, emergency repairs, handyman, HVAC, electrical, plumbing, painting and Annual Maintenance Contracts.",
    image:
      "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    slug: "professional-cleaning",
    title: "Professional Cleaning",
    description:
      "Deep, sofa, carpet, curtain, mattress, villa, move-in, commercial and steam cleaning by trained specialists.",
    image:
      "https://images.pexels.com/photos/6197108/pexels-photo-6197108.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    slug: "authority-approvals",
    title: "Authority Approvals",
    description:
      "Dubai Municipality, DDA, DCD, DEWA, Nakheel, Emaar, Dubai South, Trakhees — permit coordination start to finish.",
    image:
      "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];
